import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {ApiBaseUrl, GoogleMapUrl, GoogleMapKey, appendAddToAnyScript, removeAddToAnyScript} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PerPersonPriceComponent from '../perPersonPrice';
import { trackPromise } from 'react-promise-tracker';
import Deals from './deals';
import OwlCarousel from 'react-owl-carousel2';
import {OwlCarouselOptions} from '../../../constants';
import ShowMoreText from 'react-show-more-text';
import {withSnackbar} from "react-simple-snackbar";

class DealDetailComponent extends Component{
    static contextType = AuthContext;
    state = {
        deal_id: this.props.match.params.id,
        deal: false,
        startDate: null,
        personCount: 1,
        modal:false
    }

    blockWeekDay = date => {
        const day = date.getDay(date);
        const days = [];
        if(!this.state.deal.sunday_availbility)
            days.push(0)
        if(!this.state.deal.monday_availbility)
            days.push(1)
        if(!this.state.deal.tuesday_availbility)
            days.push(2)
        if(!this.state.deal.wednesday_availbility)
            days.push(3)
        if(!this.state.deal.thursday_availbility)
            days.push(4)
        if(!this.state.deal.friday_availbility)
            days.push(5)
        if(!this.state.deal.saturday_availbility)
            days.push(6)
        return !days.includes(day);
    }

    handleBuyNowClick = () => {
        if(!this.context.authenticated)
            this.setState({
                loginmodal: true
            })
        else if(!this.state.startDate)
            this.props.openSnackbar('Please enter date')
        else
            this.setState({
                modal : true
            })
    }

    handleModalClose = () => {
        this.setState({
            modal : false
        })
    }

    handleLoginModalClose = () => {
        this.setState({
            loginmodal : false
        })
    }

    clickHandler = (id) => {
        const deal_id = id
        this.props.history.replace(process.env.PUBLIC_URL+'/allday/deal/'+id)
        this.setState({
            deal_id: deal_id
        }, function() {
            this.pickDeal()
        })
    }

    handleLoginModalConfirm = () => {
        this.handleLoginModalClose();
        this.props.history.push(process.env.PUBLIC_URL+'/login')
    }

    handleReviewBtnClick = (event) => {
        if(!this.context.authenticated) {
            event.preventDefault();
            this.setState({
                loginmodal: true
            })
            return false;
        }
    }

    handleAddToCart = () => {
        if(!this.context.authenticated) {
            this.setState({
                loginmodal: true
            })
            return;
        }
        if(!this.state.startDate){
            this.props.openSnackbar('Please enter date')
            return;
        }
        const date = new Date(this.state.startDate);
        const startDate = date.getDate() + '-' + (date.getMonth()+1) + '-' + date.getFullYear();
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/add_to_cart/",
            {
                method: 'POST',
                body: 'deal_id='+this.props.match.params.id+'&consumer_admission_capacity_male='+this.state.personCount+'&date='+startDate,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    this.props.openSnackbar(result.message)
                    if(result.success){
                        this.context.cartCount = result.data.count;
                        this.props.history.push('/home/cart')
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    handleModalConfirm = () => {
        const date = new Date(this.state.startDate);
        const startDate = date.getDate() + '-' + (date.getMonth()+1) + '-' + date.getFullYear();
        this.handleModalClose();
        this.props.history.push({ pathname: process.env.PUBLIC_URL+'/allday/payment/'+this.props.match.params.id, state: { personCount: this.state.personCount, startDate: startDate }});
    }

    handleDateChange = date => {
        this.setState({
            startDate: date
        });
    };

    onPlusClickHandler = event => {
        this.setState({
            personCount: this.state.personCount+1
        });
    }

    onMinusClickHandler = event => {
        if(this.state.personCount > 1) {
            this.setState({
                personCount: this.state.personCount-1
            });
        }
    }

    handleFollowClick = () => {
        if(!this.context.authenticated) {
            this.setState({
                loginmodal: true
            })
            return;
        }

        fetch(ApiBaseUrl + "/consumer/follow/"+this.state.deal.category._id,
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success) {
                        let dealdata = this.state.deal
                        dealdata.is_followed = !dealdata.is_followed
                        this.setState({
                            deal: dealdata
                        });
                    }
                    this.props.openSnackbar(result.message)
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
    }

    handleFavouriteClick = () => {
        if(!this.context.authenticated) {
            this.setState({
                loginmodal: true
            })
            return;
        }

        fetch(ApiBaseUrl + "/consumer/favourite/"+this.state.deal._id,
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success) {
                        let dealdata = this.state.deal
                        dealdata.is_favourite = !dealdata.is_favourite
                        this.setState({
                            deal: dealdata
                        });
                    }
                    this.props.openSnackbar(result.message)
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
    }

    pickDeal(requestBody=''){
        const requestHeaders = (!this.context.authenticated) ?
            {
                "Content-Type" : "application/x-www-form-urlencoded"
            } :
            {
                "Content-Type" : "application/x-www-form-urlencoded",
                "Authorization": "Bearer "+this.context.token
            }
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/allday/pick_deal/"+this.state.deal_id,
                {
                    method: 'POST',
                    body: requestBody,
                    headers: requestHeaders
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        window.scrollTo(0, 0)
                        if(!result.success)
                            this.props.openSnackbar(result.message)
                        else {
                            this.setState({
                                deal: result.data,
                                startDate: null,
                                personCount: 1
                            });
                            appendAddToAnyScript();
                        }
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='deal-detail'
        this.pickDeal();
    }

    componentWillUnmount () {
        document.getElementById('body').className=''
        removeAddToAnyScript()
    }

    render(){
        return (
            this.state.deal &&
            <React.Fragment>
                <Modal id="unfollow-pop" show={this.state.modal} aria-labelledby="unfollow-pop" animation="fade">
                    <Modal.Header className="modal-header">
                        <p className="big-alert-text"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            Alert
                        </p>
                        <button onClick={this.handleModalClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <p className="unfollow-para">Have you read full DEAL DETAILS + RULES ?</p>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <button type="button" onClick={this.handleModalConfirm} className="btn btn-secondary" >Yes</button>
                        <button type="button" onClick={this.handleModalClose} className="btn btn-primary" data-dismiss="modal">No</button>
                    </Modal.Footer>
                </Modal>

                <Modal id="unfollow-pop" show={this.state.loginmodal} aria-labelledby="unfollow-pop" animation="fade">
                    <Modal.Header className="modal-header">
                        <p className="big-alert-text"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            Alert
                        </p>
                        <button onClick={this.handleLoginModalClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <p className="unfollow-para">You have to login/register to proceed further.</p>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <button type="button" onClick={this.handleLoginModalConfirm} className="btn btn-secondary" >Ok</button>
                        <button type="button" onClick={this.handleLoginModalClose} className="btn btn-primary" data-dismiss="modal">Cancel</button>
                    </Modal.Footer>
                </Modal>

                <button data-a2a-url={this.state.deal.share_url} data-a2a-title={this.state.deal.name} className="a2a_dd share-icon" type="button">
                    Share<br/>Deal
                </button>
                <div key={"deal_"+this.state.deal_id} className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 px--xs-0">
                                <div className="single-deal-detail">
                                    <div className="single-deal-image-card-main">
                                        <h4 className="deal-event-heading">{this.state.deal.category.name}</h4>
                                        <div className="single-deal-image-card">
                                            <div className="offers-tag-outer mob-badges">
                                                <ul className="list-unstyled mb-0 row">
                                                    {this.state.deal.badges.map(badge => (
                                                        <li key={badge._id}><img src={badge.image_full} alt=""/></li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <img src={this.state.deal.image} alt={this.state.deal.name}/>
                                                <div className="single-deal-image-card-heart-outer">
                                                    <i onClick={this.handleFavouriteClick} className={this.state.deal.is_favourite ? 'fa fa-heart fill-toggle' : 'fa fa-heart-o fill-toggle'}></i>
                                                </div>
                                        </div>
                                        <div className="single-deal-content">
                                            <p className="loc-pptext text_color_green">{this.state.deal.name}</p>
                                            <p className="loc-pptext">{this.state.deal.subtitle} <span
                                                className="unfollow--tab follow-btn"><button type="button" onClick={this.handleFollowClick}>{this.state.deal.is_followed ? 'unfollow' : 'follow'}</button></span></p>
                                            <p className="event-address d-flex align-items-center position-static">
                                                <i className="fa fa-map-marker position-static" aria-hidden="true"></i>{this.state.deal.companyaddress}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="single-deal-image-card-items">
                                        <div className="map_container map-left">
                                            <h4 className="location-direction-heading"><span><i
                                                className="fa  fa-map-marker"></i></span>Location (Directions)</h4>
                                            <div className="map-location-outer">
                                                <div style={{ height: '320px', width: '100%' }}>
                                                    {this.state.deal.location &&
                                                    <iframe title="map" width="100%" height="300" frameBorder="0"
                                                            style={{border: "0"}}
                                                            src={ GoogleMapUrl+ this.state.deal.location.coordinates[1] + ',' + this.state.deal.location.coordinates[0] + '&key=' + GoogleMapKey}></iframe>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deal-detail-main info-inline deal_detail_m deal_detail_mob">
                                            <p className="label color-60f font-weight-bold">
                                                <i className="fa fa-list-alt" aria-hidden="true"></i>
                                                Deal Detail(s)
                                            </p>
                                            <div className="label_info more"><ShowMoreText
                                                /* Default options */
                                                lines={3}
                                                more='Show more'
                                                less='Show less'
                                                anchorClass='morelink'
                                                expanded={false}
                                            >{this.state.deal.description}</ShowMoreText></div>
                                        </div>
                                        <div className="new_btn review_btn btn-website">
                                            <Link onClick={this.handleReviewBtnClick.bind(this)} to={process.env.PUBLIC_URL+'/vendor/reviews/'+this.state.deal.category._id}><button type="button" className="buy-btn">View review and ratings</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7 px--xs-0">
                                <div className="single-deal-detail">
                                    <div className="share-deal-top">
                                        <div className="position-relative">
                                            <button data-a2a-url={this.state.deal.share_url} data-a2a-title={this.state.deal.name} className="a2a_dd" type="button">
                                                Share<br/> Deal
                                            </button>
                                        </div>
                                    </div>
                                    <div className="single-deal-event-detail">
                                        <p className="deal-event-heading d-none d-lg-block">{this.state.deal.category.name}</p>
                                        <h4 className="deal-event-heading custom-event-heading">{this.state.deal.name}</h4>

                                        <div className="deal-badges-outer d-none">
                                            <ul className="list-unstyled mb-0 d-flex">
                                                {this.state.deal.badges.map(badge => (
                                                    <li key={badge._id}><img src={badge.image_full} alt=""/></li>
                                                ))}
                                            </ul>
                                        </div>
                                        <p className="loc-pptext">{this.state.deal.subtitle} <span
                                            className="unfollow--tab follow-btn"><button type="button" onClick={this.handleFollowClick}>{this.state.deal.is_followed ? 'unfollow' : 'follow'}</button></span></p>
                                        <p className="event-address d-flex align-items-center position-static"><i
                                            className="fa fa-map-marker position-static" aria-hidden="true"></i>{this.state.deal.companyaddress}
                                        </p>
                                        <div className="payment-sec-main bg-grey">
                                            <h4 className="payment-heading">payment</h4>
                                            <div className="calendar_block center-md">
                                                <div className="row">
                                                    <div className="col-md-6 col-6">

                                                        <div
                                                            className="date-cart-width date_block date_select_block border-none">
                                                            <span className="date_select_date">Select date</span>
                                                            <div className="date-icon"><i className="fa fa-calendar"></i><DatePicker
                                                                maxDate={new Date(new Date().getFullYear()+1, new Date().getMonth(), new Date().getDate())}
                                                                showPopperArrow={false}
                                                                selected={this.state.startDate}
                                                                placeholderText="DD-MM-YYYY"
                                                                onChange={this.handleDateChange}
                                                                filterDate={this.blockWeekDay}
                                                                minDate={new Date()}
                                                                dateFormat="dd-MM-yyyy"
                                                            />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-6 col-6">
                                                        <div className="date_block date_count_block">
                                                            <span className="date_per_person">select person</span>
                                                            <div className="outer-setting--commmon">
                                                                <div className="input_div">
                                                                    <input type="button" value="-" id="moins" onClick={this.onMinusClickHandler} className="minus"/>
                                                                    <input type="text" size="25" value={this.state.personCount} id="count" className="count__val" readOnly/>
                                                                    <input type="button" value="+" id="plus" onClick={this.onPlusClickHandler} className="plusin"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="price_col">
                                                <div className="">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="payment-block borbt0">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <p className="">
                                                                            Full Price :<span className="l10"><span className="payment_price letters"> ${this.state.deal.consumer_admission_fees_male && <PerPersonPriceComponent persons={this.state.personCount} price={this.state.deal.consumer_admission_fees_male} fee={this.state.deal.commission}/> }</span></span>
                                                                            <span className="small_text">(All taxes and tip included in the price)</span>

                                                                        </p>
                                                                        <span className="dis-deal small_text">(You will get more discount on deals by applying promo code, if you buy them from cart)</span>

                                                                    </div>
                                                                </div>
                                                                <div className="row mt-3">
                                                                    <div className="col-6 pr-1 pr-lg-3">

                                                                        <button onClick={this.handleAddToCart} type="button" className="cart-btn grad_btn box-shadow0 bg-grey">
                                                                            <i className="fa fa-shopping-cart"></i>
                                                                            Add to cart
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6 pl-1 pl-lg-3">
                                                                        <button onClick={this.handleBuyNowClick} type="button" className="buy-btn flex-sm"><span></span>Buy Now</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deals_main-sec">
                                            <h4 className="selected-day-title">Deal availabe on these days</h4>
                                            <div className="day-row">
                                                <div className="each-day">
                                                    <span className={this.state.deal.monday_availbility ? 'day-count highlighted' : 'day-count'}>M</span>
                                                    <p className="status-color">{this.state.deal.monday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.tuesday_availbility ? 'day-count highlighted' : 'day-count'}>T</span>
                                                    <p className="status-color">{this.state.deal.tuesday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.wednesday_availbility ? 'day-count highlighted' : 'day-count'}>W</span>
                                                    <p className="status-color">{this.state.deal.wednesday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.thursday_availbility ? 'day-count highlighted' : 'day-count'}>T</span>
                                                    <p className="status-color">{this.state.deal.thursday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.friday_availbility ? 'day-count highlighted' : 'day-count'}>F</span>
                                                    <p className="status-color">{this.state.deal.friday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.saturday_availbility ? 'day-count highlighted' : 'day-count'}>S</span>
                                                    <p className="status-color">{this.state.deal.saturday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                                <div className="each-day">
                                                    <span className={this.state.deal.sunday_availbility ? 'day-count highlighted' : 'day-count'}>S</span>
                                                    <p className="status-color">{this.state.deal.sunday_availbility ? 'Open' : 'Close'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="info">
                                            <div className="business-sec">
                                                <div className="full_Width">
                                                    <p className="label"><img className="watch_img" src={`${process.env.PUBLIC_URL}/image/clock.svg`} alt=""/>Business Hours</p> <p className="label_info">{this.state.deal.businessstarttime ? this.state.deal.businessstarttime : 'None'}</p>
                                                </div>
                                            </div>
                                            <div className="business-sec">
                                                <div className="full_Width">
                                                    <p className="label"><img className="watch_img" src={`${process.env.PUBLIC_URL}/image/clock.svg`} alt=""/>Event Time</p> <p className="label_info">{this.state.deal.starttime ? this.state.deal.starttime : 'None'}</p>
                                                </div>
                                            </div>

                                            <div className="h_line mob-none"></div>
                                            <div className="deal-detail-main info-inline">
                                                <div className="full_Width">
                                                    <p className="label font-weight-bold"><i
                                                        className="fa fa-building-o" aria-hidden="true"></i>About the company</p>
                                                    <div className="label_info more"><ShowMoreText
                                                        /* Default options */
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass='morelink'
                                                        expanded={false}
                                                    >

                                                        {this.state.deal.aboutcompany}
                                                    </ShowMoreText></div>
                                                </div>
                                            </div>
                                            <div className="deal-detail-main info-inline deal_detail_m deal_detail_web">
                                                <p className="label color-60f font-weight-bold">
                                                    <i className="fa fa-list-alt" aria-hidden="true"></i>
                                                    Deal Detail(s)
                                                </p>
                                                <div className="label_info more"><ShowMoreText
                                                    /* Default options */
                                                    lines={3}
                                                    more='Show more'
                                                    less='Show less'
                                                    anchorClass='morelink'
                                                    expanded={false}
                                                >{this.state.deal.description}</ShowMoreText></div>
                                            </div>
                                            <div className="deal-detail-main info info-inline">
                                                <div className="full_Width">
                                                    <p className="label color-60f font-weight-bold"><img
                                                        className="watch_img" src={`${process.env.PUBLIC_URL}/image/checked.svg`} alt=""/>Deal Rule(s)</p>
                                                    <div className="label_info more"><ShowMoreText
                                                        /* Default options */
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass='morelink'
                                                        expanded={false}
                                                    >{this.state.deal.rule}</ShowMoreText></div>
                                                </div>
                                            </div>
                                            <div className="map_container map-right-mob">
                                                <h4 className="location-direction-heading"><span><i
                                                    className="fa  fa-map-marker"></i></span>Location (Directions)</h4>
                                                <div className="map-location-outer">
                                                    <div style={{ height: '320px', width: '100%' }}>
                                                        {this.state.deal.location &&
                                                        <iframe title="map" width="100%" height="300" frameBorder="0"
                                                                style={{border: "0"}}
                                                                src={ GoogleMapUrl+ this.state.deal.location.coordinates[1] + ',' + this.state.deal.location.coordinates[0] + '&key=' + GoogleMapKey}></iframe>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="deal_detail_like_more">
                                            {this.state.deal.more_like_deals.length > 0 &&
                                            <div className="each-category-outer">
                                                <div className="category-header">
                                                    <h2 className="category-heading"><span className="text_color_green">More Like this</span>
                                                    </h2>
                                                </div>
                                                <OwlCarousel options={OwlCarouselOptions}
                                                             className="owl-carousel owl-theme">
                                                    <Deals clickHandler={id => this.clickHandler(id)}
                                                           deals={this.state.deal.more_like_deals}/>
                                                </OwlCarousel>
                                            </div>
                                            }
                                            <div className="new_btn review_btn btn-mob">
                                                <Link onClick={this.handleReviewBtnClick.bind(this)} to={process.env.PUBLIC_URL+'/vendor/reviews/'+this.state.deal.category._id}><button type="button" className="buy-btn font-weight-bold">View review and ratings</button></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(DealDetailComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});